import { isEmpty, isPlainObject } from 'lodash';
import { ServerSideEventError } from './ServerSideEventError';
import type { EventType } from './types';

type ServerSideEventMessage = Pick<MessageEvent<string>, 'data' | 'type' | 'lastEventId'>;

/** Normalize named stream messages while preserving default-message payloads for existing consumers. */
export const transformServerSideEventMessage = (
    message: ServerSideEventMessage,
    named = false
): EventType | undefined => {
    let eventData: EventType;
    try {
        eventData = JSON.parse(message.data);
    } catch (cause) {
        const error = new ServerSideEventError('parse', cause);
        throw error;
    }
    if (!isPlainObject(eventData) || isEmpty(eventData)) return undefined;
    const transformedEvent: EventType = named
        ? { ...eventData, name: message.type, id: message.lastEventId }
        : eventData;
    return transformedEvent;
};
